import DateCell from '../../../elements/Table/Cells/DateCell'
import React from 'react'
import CustomTable from '../../../elements/Table/CustomTable'
import StatusCell from '../../../elements/Table/Cells/StatusCell'
import MoneyCell from '../../../elements/Table/Cells/MoneyCell'
import FileCell from '../../../elements/Table/Cells/FileCell'
import CustomSelect from '../../../elements/Select/CustomSelect'
import { compose } from 'recompose'
import withData from '../../../elements/Select/withData'
import withKeyValue from '../../../elements/HOC/WithKeyValue'
import { isEmpty, uniq } from 'lodash'
import withSort from '../../../elements/HOC/withSort'
import { Link } from 'react-router-dom'
import { withRouter } from 'react-router-dom'
import OrganisationsSelect from '../../../elements/Select/Organistaions'
import { strVal } from '../../../modules/Utils'

function getStatusSelect(list) {
  return compose(withData({ data: uniq(list.map((l) => l.status)) }), withKeyValue(), withSort)(CustomSelect)
}

function filterArraySelect(filter, row) {
  if (isEmpty(filter.value)) return true
  return filter.value.includes(row[filter.id])
}

function List(props) {
  const { list, fetch, fetching, company, onChangeCompany } = props
  const StatusSelect = React.useMemo(() => getStatusSelect(list), [list.length])
  const columns = [
    {
      Header: 'SystemID',
      accessor: '_key',
      width: 200,
      Cell: ({ value, original }) => (
        <Link
          to={{
            pathname: `/people/salaries/${original._key}/update`,
          }}>
          {value}
        </Link>
      ),
    },

    { Header: 'Employee', accessor: 'employee.fn' },
    {
      Header: 'Payroll',
      accessor: 'payroll.code',
      hideable: true,
      Cell: ({ value, original }) => (
        <Link to={`/people/payrolls/${strVal(original, 'payroll._key')}/update`}>{value}</Link>
      ),
    },
    {
      Header: 'Salary Date',
      accessor: 'date',
      Cell: DateCell,
    },

    {
      Header: 'Company',
      accessor: 'company.fn',
      width: 300,
      hideDefault: true,
      hideable: true,
    },
    {
      Header: 'Bank',
      accessor: 'bank.nickname',
      hideDefault: true,
      hideable: true,
    },
    { Header: 'Currency', accessor: 'currency' },
    { Header: 'Amount', accessor: 'amount', Cell: MoneyCell },
    {
      Header: 'Status',
      accessor: 'status',
      Cell: StatusCell,
      filterMethod: filterArraySelect,
      Filter: ({ onChange, filter }) => (
        <StatusSelect
          showSearch={false}
          onChange={(value) => onChange(value)}
          value={filter ? filter.value : []}
          mode="multiple"
        />
      ),
    },
    { Header: 'File', accessor: 'file', Cell: FileCell },
  ]

  return (
    <CustomTable
      data={list}
      defaultPageSize={20}
      isFilterable={true}
      fetching={fetching}
      fetch={fetch}
      ExtraOptionsButtons={() => (
        <OrganisationsSelect
          value={company}
          onChange={onChangeCompany}
          placeholder={'Filter by a company'}
          size={'small'}
          style={{ width: '450px', paddingRight: 20, float: 'right' }}
        />
      )}
      // CreateButton={() => (
      //   <Button
      //     type={'primary'}
      //     size="small"
      //     icon={'plus'}
      //     onClick={() => {
      //       props.history.push({
      //         pathname: '/people/salaries/new/',
      //       })
      //     }}>
      //     Add new Salaries
      //   </Button>
      // )}
      columns={columns}
    />
  )
}

List.propTypes = {}
List.defaultProps = {}

export default withRouter(List)
